<template>
  <BackgroundImage
    :background="data.heroImage"
    :class="{
      'bg-center': true,
    }"
    :preload="true"
    _type="imageBackground"
    background-size="full-page"
  >
    <div
      :class="{
        'container mx-auto px-0 pb-20 pt-150px text-www-color-white': true,
      }"
    >
      <span
        :class="{
          'text-sm font-medium uppercase': true,
        }"
        >{{ data.pageType }}</span
      >

      <h1
        :class="{
          'pt-4 text-28px font-black lg:text-60px lg:leading-69px': true,
        }"
      >
        {{ data.title }}
      </h1>

      <p
        :class="{
          'pt-4 text-xl': true,
        }"
      >
        {{ data.subtitle }}
      </p>

      <WistiaVideoWatchNow
        v-if="data.video"
        v-bind="{ ...data.video, duration: data.wistiaVideoMetadata?.duration }"
      >
        {{ data.video.linkText }}
      </WistiaVideoWatchNow>
    </div>
  </BackgroundImage>
</template>

<script lang="ts" setup>
import BackgroundImage from '~/components/Atmos/BackgroundImage/BackgroundImage.vue';
import WistiaVideoWatchNow from '~/components/Atmos/WistiaVideo/WistiaVideoWatchNow.vue';
import type { QueryCaseStudyResult } from '~/sanity/types';

interface Props {
  data: NonNullable<QueryCaseStudyResult>['caseStudyHero'];
}

defineProps<Props>();
</script>
